<!-- 
Template for an expandable table row.
-->
<template>
  <tr class="v-datatable__expand-row">
    <td :colspan="colspan" :class="['v-datatable__expand-col ' + (expanded ? 'v-datatable__expand-col--expanded' : '')]">
      <v-expand-transition>
        <slot/>
      </v-expand-transition>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    colspan: {
      type: Number,
      required: true
    },
    expanded: {
      type: Boolean,
      required: true
    }
  }
};
</script>
